import clone from 'clone';
import * as React from 'react';
import styled from 'styled-components';

// Value is used as name for convenience.
export type CheckboxProps = {
    id?:string,
    text:string,
    value:string,
    checked:boolean,
    disabled?:boolean,
    onChange?:(value:string, checked:boolean, e?:React.ChangeEvent<HTMLInputElement>)=>void,
    onClick?:(value:string, checked:boolean, e?:React.MouseEvent<HTMLInputElement, MouseEvent>)=>void
}

export function Checkbox(props:CheckboxProps)
{
    function handleChange(e:React.ChangeEvent<HTMLInputElement>)
    {
        props.onChange && props.onChange(e.currentTarget.value, e.currentTarget.checked, e);
    }

    function handleClick(e:React.MouseEvent<HTMLInputElement, MouseEvent>)
    {
        props.onClick && props.onClick(e.currentTarget.value, e.currentTarget.checked, e);
    }

    const generatedIdRef = React.useRef<string>(props.id ?? `checkbox-${Math.random().toString(36).slice(2, 9)}`);
    const inputId = props.id === undefined ? generatedIdRef.current : props.id;

    return (
        <span style={{display:'inline-flex', alignItems:'center', gap:'4px'}}>
            <input type="checkbox" 
                id={inputId}
                name={props.value} 
                value={props.value} 
                checked={props.checked}
                onChange={handleChange}
                onClick={handleClick}
                disabled={props.disabled} />
            <label htmlFor={inputId}>
                {props.text}
            </label>
        </span>
    );
}

export type CheckboxOption = { text:string, value:string, checked:boolean };
export type CheckboxListProps = {
    flexDirection?:'vertical'|'horizontal',
    disabled?:boolean,
    options:CheckboxOption[],
    indent?: boolean,
    onChange:(item:CheckboxOption, allItems:CheckboxOption[])=>void
}
export function CheckboxList(props:CheckboxListProps)
{
    function handleChange(value:string, checked:boolean)
    {
        const options = clone(props.options);
        const changed = options.find(o => o.value === value);
        if(changed){
            changed.checked = checked;
            props.onChange(changed, options);
        }
    }

    return (
        <>
            {props.options && props.options.length > 0 &&
                <CheckboxUnorderedList indent={props.indent}>
                    {props.options.map((o,i) => {
                        return (
                            <CheckboxListItem key={i}
                                flexDirection={props.flexDirection===undefined ? 'vertical' : props.flexDirection}>
                                <Checkbox
                                    {...o}
                                    disabled={props.disabled}
                                    onChange={handleChange}
                                    id={"checkbox-" + i}
                                />
                            </CheckboxListItem>
                        );
                    })}
                </CheckboxUnorderedList>
            }
        </>
    );
}

const CheckboxUnorderedList = styled.ul<{ indent: boolean}>`
    list-style-type: none;
    padding: 0px;
    margin-top:0px;
    padding-left: ${props => props.indent? '14px' : '0'};
`;

const CheckboxListItem = styled.li<{flexDirection:'vertical' | 'horizontal'}>`
    display: ${props => props.flexDirection === 'vertical' ? 'list-item' : 'inline-block'};
`;